<template>
  <TeleportWithDirection to="body">
    <div class="fixed inset-0 bg-black/20 dark:bg-black/50 backdrop-blur-sm flex items-center justify-center z-[100]">
      <div class="bg-white dark:bg-slate-800 rounded-xl w-full max-w-md border border-slate-200 dark:border-slate-700 overflow-hidden">
        <!-- Header -->
        <div class="p-6 border-b border-slate-200 dark:border-slate-700">
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-semibold text-slate-900 dark:text-white">
              {{ $t('COMPOSE_MODE_PICKER.TITLE') }}
            </h3>
            <button
              @click="$emit('close')"
              class="p-1 rounded-md text-slate-400 hover:text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-700"
            >
              <Icon icon="i-lucide-x" size="20" />
            </button>
          </div>
          <p class="mt-2 text-sm text-slate-600 dark:text-slate-400">
            {{ $t('COMPOSE_MODE_PICKER.DESCRIPTION') }}
          </p>
        </div>

        <!-- Mode Options -->
        <div class="p-6 space-y-4">
          <!-- Single Conversation -->
          <button
            @click="selectMode('single')"
            class="w-full p-4 text-left border border-slate-200 dark:border-slate-700 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors group"
          >
            <div class="flex items-start space-x-3">
              <div class="flex-shrink-0 w-10 h-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                <Icon icon="i-lucide-message-circle" class="text-blue-600 dark:text-blue-400" size="20" />
              </div>
              <div class="flex-grow">
                <h4 class="font-medium text-slate-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400">
                  {{ $t('COMPOSE_MODE_PICKER.SINGLE_CONVERSATION.TITLE') }}
                </h4>
                <p class="mt-1 text-sm text-slate-600 dark:text-slate-400">
                  {{ $t('COMPOSE_MODE_PICKER.SINGLE_CONVERSATION.DESCRIPTION') }}
                </p>
              </div>
            </div>
          </button>

          <!-- Bulk Broadcast -->
          <button
            @click="selectMode('bulk')"
            class="w-full p-4 text-left border border-slate-200 dark:border-slate-700 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors group"
          >
            <div class="flex items-start space-x-3">
              <div class="flex-shrink-0 w-10 h-10 bg-green-100 dark:bg-green-900/30 rounded-lg flex items-center justify-center">
                <Icon icon="i-lucide-send" class="text-green-600 dark:text-green-400" size="20" />
              </div>
              <div class="flex-grow">
                <h4 class="font-medium text-slate-900 dark:text-white group-hover:text-green-600 dark:group-hover:text-green-400">
                  {{ $t('COMPOSE_MODE_PICKER.BULK_BROADCAST.TITLE') }}
                </h4>
                <p class="mt-1 text-sm text-slate-600 dark:text-slate-400">
                  {{ $t('COMPOSE_MODE_PICKER.BULK_BROADCAST.DESCRIPTION') }}
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </TeleportWithDirection>
</template>

<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import TeleportWithDirection from 'dashboard/components-next/TeleportWithDirection.vue';

const emit = defineEmits(['close', 'select-mode']);

const selectMode = (mode) => {
  emit('select-mode', mode);
};
</script>